export const removeMiddleName = (name: string | null) => {
  if (!name) return '';
  const arr = name.split(' ');
  return `${arr[0]} ${arr[1]}`;
};
